import React from "react";
import styles from "./CoreTeam.module.css";
import imgNarasimha from "../../../src/assets/images/coreTeam/Narasimha Naidu.jpg";
import imgPraveen from "../../../src/assets/images/coreTeam/Praveen Naidu.jpg";
import imgTakeshi from "../../../src/assets/images/coreTeam/Takeshi Ogura.jpg";
import imgAnil from "../../../src/assets/images/coreTeam/Anil Basotra.jpg";
import imgVidya from "../../../src/assets/images/coreTeam/Vidya.jpg";
import imgMohan from "../../../src/assets/images/coreTeam/Mohan Reddy.jpg";
import imgHema from "../../../src/assets/images/coreTeam/Hema Naidu.jpg";
import imgBasavaraj from "../../../src/assets/images/coreTeam/Basavaraj Gadad.jpg";
import imgAbbas from "../../../src/assets/images/coreTeam/Abbas.jpg";
import imgAaqib from "../../../src/assets/images/coreTeam/Aaqib.jpg";

const CoreTeam = () => {
  const teamMembers = [
    {
      name: "Narasimha Naidu",
      role: "Founder & CEO",
      image: imgNarasimha,
    },
    {
      name: "Praveen Naidu",
      role: "CFO - India",
      image: imgPraveen,
    },
    {
      name: "Takeshi Ogura",
      role: "Asia Head - KTC Holdings Japan",
      image: imgTakeshi,
    },
    {
      name: "Anil Basotra",
      role: "Director - KTC Holdings India",
      image: imgAnil,
    },
    {
      name: "Vidya",
      role: "Customer success manager - India",
      image: imgVidya,
    },
    {
      name: "Mohan Reddy",
      role: "BDM ( Telangana & AP)",
      image: imgMohan,
    },
    {
      name: "Hema Naidu",
      role: "Planning & Strategy(India)",
      image: imgHema,
    },
    {
      name: "Basavaraj Gadad",
      role: "Zonal Head - Business (Mumbai & Pune)",
      image: imgBasavaraj,
    },
    {
      name: "Abbas",
      role: "BDM (Bengaluru & Chennai)",
      image: imgAbbas,
    },
    {
      name: "Aaqib",
      role: "Manager STEM Services (India)",
      image: imgAaqib,
    },
  ];

  return (
    <section className={styles.coreTeamSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle} data-aos="fade-up">
          Core <span>STEMx</span> Team
        </h2>
        <div className={styles.teamGrid}>
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className={styles.teamCard}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className={styles.imageWrapper}>
                <div className={styles.imageContainer}>
                  <img
                    src={member.image}
                    alt={member.name}
                    className={styles.memberImage}
                  />
                </div>
              </div>
              <div className={styles.memberInfo}>
                <h3 className={styles.memberName}>{member.name}</h3>
                <p className={styles.memberRole}>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreTeam;
